import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const ShopifySyncButton = ({ onDone }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/shopify/status").then((r) => setStatus(r.data)).catch(() => {}); }, []);

  const sync = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/shopify/sync-products");
      toast.success(`Shopify: ${data.total} prodotti · ${data.created} nuovi · ${data.updated} aggiornati${data.unmapped.length ? ` · ${data.unmapped.length} senza step` : ""}`);
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (!status) return null;
  return (
    <button data-testid="products-shopify-sync-btn" className="fs-btn-ghost !py-3" onClick={sync} disabled={busy} title={status.last_sync?.ts ? `Ultima sync: ${new Date(status.last_sync.ts).toLocaleString("it-IT")}` : ""}>
      <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> Sincronizza da Shopify
    </button>
  );
};
